<mat-card appearance="outlined">
  <section>
    <div class="flex flex-row gap-6 my-8" style="font-size:larger">
      <span>{{labName}}</span>
    </div>
    <div class="flex flex-row gap-6 my-8" style="font-size:small">
      <span style="font-weight:bold;">Lab Type: </span>
      <span>{{labType}}</span>
      <span style="font-weight:bold;">State Number: </span>
      <span>{{cliaSchedule}} {{stateNumber}}</span>
      <span style="font-weight:bold;">Clia Number: </span>
      <span>{{cliaNumber}}</span>
    </div>
  </section>
  <section>
    <mat-tab-group dynamicHeight [(selectedIndex)]="labService.currentTab">

      <mat-tab label="Demographics" *ngIf="tabVisible('demographics')">
        <app-demographics [stateNumber]="stateNumber"></app-demographics>
      </mat-tab>

      <mat-tab label="Surveys" *ngIf="tabVisible('survey')">
        <app-surveys [stateNumber]="stateNumber"></app-surveys>
      </mat-tab>

      <mat-tab label="Associated" *ngIf="tabVisible('associated')">
        <app-associated [stateNumber]="stateNumber"></app-associated>
      </mat-tab>

      <mat-tab label="Specialty" *ngIf="tabVisible('specialty')">
        <app-specialty [stateNumber]="stateNumber"></app-specialty>
      </mat-tab>

      <mat-tab label="Proficiency" *ngIf="tabVisible('proficiency')">
        <app-proficiency [stateNumber]="stateNumber"></app-proficiency>
      </mat-tab>

      <mat-tab label="License/Cash" *ngIf="tabVisible('licenseCash')">
        <app-license-cash [stateNumber]="stateNumber"></app-license-cash>
      </mat-tab>

      <mat-tab label="Change Log" *ngIf="tabVisible('changeLog')">
        <app-change-log [stateNumber]="stateNumber"></app-change-log>
      </mat-tab>

    </mat-tab-group>
  </section>
</mat-card>
